import { z } from 'zod';
export const ClaseSchema = z.object({
    id: z.string().uuid(),
    sucursalId: z.string().uuid(),
    tarifaId: z.string().uuid(),
    tarifaColor: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/)
        .nullable()
        .optional(),
    tipoClase: z.string(),
    disciplina: z.string().nullable().optional(),
    meetingPointId: z.string().uuid(),
    empleadoId: z.string().uuid().nullable().optional(),
    fechaHoraInicio: z.string(),
    duracionHoras: z.number(),
    capacidadMin: z.number(),
    capacidadMax: z.number(),
    estado: z.string(),
    fechaDictada: z.string().nullable().optional(),
    precioOverride: z.union([z.string(), z.number()]).nullable().optional(),
    precioOverrideMotivo: z.string().nullable().optional(),
    precioOverrideUusuarioId: z.string().uuid().nullable().optional(),
    precioOverrideEn: z.string().nullable().optional(),
    // Datos de la reserva asociada (la primera, en caso de varias). Sirven
    // para mostrar "quien viene" en las cards del planning de clases.
    reservaId: z.string().uuid().nullable().optional(),
    reservaCodigo: z.string().nullable().optional(),
    clienteNombre: z.string().nullable().optional(),
    clienteTelefono: z.string().nullable().optional(),
});
export const ClasesListSchema = z.object({
    items: z.array(ClaseSchema),
});
